// src/hooks/useDevSecretShortcut.ts
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import toastConfig from '../utils/constants/toastConfig';
import { UserInfo } from '../types';

export default function useDevSecretShortcut(
  setUserInfo: React.Dispatch<React.SetStateAction<UserInfo>>
) {
  const ENABLE_SHORTCUT = process.env.REACT_APP_ENABLE_SECRET_SHORTCUT === 'true';

  useEffect(() => {
    if (!ENABLE_SHORTCUT) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.altKey && e.code === 'KeyF') {
        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');

        setUserInfo({
          contact: {
            profile: '',
            email: `alban.fresil+${pad(now.getDate())}${pad(
              now.getMonth() + 1
            )}${pad(now.getHours())}${pad(now.getMinutes())}@gmail.com`,
            firstName: 'Marc',
            lastName: 'Assin',
            phone: '06 95 84 62 32',
            function: 'Acheteur',
            howDidYouKnowUs: 'Bouche à oreille',
          },
          company: {
            countryCode: 'FR',
            companyName: "Lucot Passage Gonin",
            nbtva: 'FR82850290933',
            siret: '85029093300017',
            address: '11 Rue du Baigneur',
            postalCode: '75018',
            siren: '850290933',
            city: 'Paris',
          },
          receiveRecommendation: { email: false, sms: false },
          documents: {
            companyRegistration: [
              {
                name: 'kbis.png',
                data: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgA…',
              },
            ],
            identityCard: [
              {
                name: 'kbis.png',
                data: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgA…',
              },
            ],
            identityCardBack: [],
            other: [],
          },
        });
        toast.success('Secret data loaded !', toastConfig);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [ENABLE_SHORTCUT, setUserInfo]);
}
